import type { IndexUiState, UiState } from "instantsearch.js/es/types";
import type { RouterProps } from "instantsearch.js/es/middlewares/createRouterMiddleware";
import { history } from "instantsearch.js/es/lib/routers";
import { uiStateToSerializableParams } from "components/Algolia/utils";

export type BrowserRouteState = Omit<IndexUiState, "configure">;

export const buildGlobalSearchAlgoliaRouting = (
  localizedSearchIndexName: string
): RouterProps<UiState, BrowserRouteState> => {
  const algoliaRouting: RouterProps<UiState, BrowserRouteState> = {
    router: history({ cleanUrlOnDispose: false }),
    stateMapping: {
      stateToRoute(uiState) {
        const filteredSearchState = uiStateToSerializableParams(
          uiState,
          localizedSearchIndexName,
          {}
        );

        return filteredSearchState;
      },
      routeToState(routeState) {
        return {
          [localizedSearchIndexName]: routeState
        };
      }
    }
  };

  return algoliaRouting;
};
